<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item
          label="积分渠道名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            type="text"
            max-length="6"
            v-decorator="[
              'integralChannelName',
              {
                rules: [{ required: true, message: '积分渠道名称(最多6个字)' }]
              }
            ]"
            placeholder="积分渠道名称"
          ></a-input>
        </a-form-item>
        <a-form-item
          label="积分渠道数值"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            min="0"
            onkeyup="this.value=this.value.replace(/\D|^0/g,'')"
            onafterpaste="this.value=this.value.replace(/\D|^0/g,'')"
            v-decorator="[
              'integralChannelNum',
              {
                rules: [
                  { required: true, message: '请输入积分渠道数值(正整数)' }
                ]
              }
            ]"
            placeholder="请输入积分渠道数值"
            type="number"
          />
        </a-form-item>
        <a-form-item
          label="积分渠道类型"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <j-dict-select-tag
            v-decorator="[
              'integralChannelDict',
              { rules: [{ required: true, message: '请选择积分渠道类型' }] }
            ]"
            :triggerChange="true"
            dictCode="integral_channel_type"
          />
        </a-form-item>
        <a-form-item
          label="每人天获得积分上限"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            min="0"
            onkeyup="this.value=this.value.replace(/\D|^0/g,'')"
            onafterpaste="this.value=this.value.replace(/\D|^0/g,'')"
            v-decorator="[
              'integralChannelDayLimit',
              {
                rules: [
                  {
                    required: true,
                    message: '请输入每人天获得积分上限(正整数)'
                  }
                ]
              }
            ]"
            placeholder="请输入每人天获得积分上限"
            type="number"
          />
        </a-form-item>
        <a-form-item
          label="每天发放积分上限"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            min="0"
            onkeyup="this.value=this.value.replace(/\D|^0/g,'')"
            onafterpaste="this.value=this.value.replace(/\D|^0/g,'')"
            v-decorator="['integralChannelTotalLimit', { rules: [] }]"
            placeholder="请输入每天发放积分上限"
            type="number"
          ></a-input>
        </a-form-item>
        <a-form-item
          label="关联活动"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <j-dict-select-tag
            v-decorator="[
              'associationActivity',
              { rules: [{ required: true, message: '请选择关联活动' }] }
            ]"
            :triggerChange="true"
            placeholder="请选择关联活动"
            dictCode="association_activity"
          ></j-dict-select-tag>
        </a-form-item>
        <a-form-item
          label="启用状态"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <!--<j-dict-select-tag  v-decorator="['status', { rules: [{ required: true, message: '请选择启用状态' }] }]" :triggerChange="true" placeholder="请选择启用状态" dictCode="obj_status"/>-->
          <a-switch
            checked-children="启用"
            un-checked-children="禁用"
            v-decorator="['usedStatus']"
            v-show="Ok"
            default-checked
          />
          <a-switch
            checked-children="启用"
            un-checked-children="禁用"
            v-decorator="['usedStatus']"
            v-show="unOk"
          />
        </a-form-item>
      </a-form>
    </a-spin>
  </j-modal>
</template>

<script>
import { getAction, httpAction } from '@/api/manage';
import pick from 'lodash.pick';
import JDate from '@/components/jeecg/JDate';
import JImageUpload from '@/components/jeecg/JImageUpload';
import JMultiSelectTag from '@/components/dict/JMultiSelectTag';

export default {
  name: 'IntegralConfigModal',
  components: {
    JDate,
    JImageUpload,
    JMultiSelectTag
  },
  props: {},
  data() {
    return {
      form: this.$form.createForm(this),
      title: '操作',
      width: 800,
      visible: false,
      disableSubmit: false,
      model: {},
      Ok: false,
      unOk: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      validatorRules: {},
      url: {
        add: process.env.VUE_APP_CMS_MARKETING + '/integral/config/add',
        edit: process.env.VUE_APP_CMS_MARKETING + '/integral/config/edit'
      }
    };
  },
  created() {},
  methods: {
    add() {
      this.edit({});
    },
    edit(record) {
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(
            this.model,
            'integralChannelName',
            'integralChannelNum',
            'integralChannelDict',
            'integralChannelDayLimit',
            'integralChannelTotalLimit',
            'associationActivity',
            'usedStatus'
          )
        );
      });
      if (this.model.usedStatus === '1') {
        this.Ok = true;
        this.unOk = false;
        console.log('usedStatus::::' + this.model.usedStatus);
        console.log('Ok::::' + this.Ok);
        console.log('unOk::::' + this.unOk);
      } else {
        this.unOk = true;
        this.Ok = false;
        console.log('usedStatus::::' + this.model.usedStatus);
        console.log('Ok::::' + this.Ok);
        console.log('unOk::::' + this.unOk);
      }
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk() {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let httpurl = '';
          let method = '';
          if (!this.model.id) {
            httpurl += this.url.add;
            method = 'post';
          } else {
            httpurl += this.url.edit;
            method = 'post';
          }
          let formData = Object.assign(this.model, values);
          console.log('表单提交数据', formData);
          httpAction(httpurl, formData, method)
            .then(res => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.confirmLoading = false;
              that.close();
            });
        }
      });
    },
    handleCancel() {
      this.close();
    },
    popupCallback(row) {
      this.form.setFieldsValue(
        pick(
          row,
          'integralChannelName',
          'integralChannelNum',
          'integralChannelDict',
          'integralChannelDayLimit',
          'integralChannelTotalLimit',
          'associationActivity',
          'usedStatus'
        )
      );
    }
  }
};
</script>
